module.exports = __webpack_public_path__ + "img/FEDEX.a04d16db.svg";